import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const NullLocationMessageContainer = styled(Flex, {
  marginTop: '27.25px',
  marginLeft: 'auto',
  marginRight: 'auto',
  textAlign: 'center',
  width: '90%',
});

export const StyleForHeader = {
  marginTop: '8px',
  'abyss-box-root': {
    backgroundColor: '$bgHeaderColor',
    '@media (max-width: 744px)': {
      borderBottom: 'solid',
      borderColor: '$headerCardWrapperBorderColor',
    },
    borderBottom: 'solid 1px $core.color.neutral.20',
    padding: '24px 16px',
    height: 'auto',
  },
};

export const InfoButtonStyle = {
  'abyss-button-root': {
    width: 'auto',
    padding: '0px',
    minHeight: '16px',
    height: '16px',
    lineHeight: '16px',
  },
};
